import React from "react";
import { RadixRadioGroup } from "../../primitives/RadixRadioGroup";
export var MainItemSelector = function (_a) {
    var items = _a.items, selectedIndex = _a.selectedIndex, onSelect = _a.onSelect;
    var options = items.map(function (item) { return ({
        value: String(item.selectionIndex),
        label: React.createElement("span", null, item.name)
    }); });
    return (React.createElement(RadixRadioGroup, { name: "main-item-selector", options: options, value: String(selectedIndex), onValueChange: function (value) { return onSelect(Number(value)); }, ariaLabel: "Main item selector", className: "item-customization-radio-list", optionClassName: "item-customization-radio-option" }));
};
